export const ACCEPTED_IMPORT_FILE_TYPES = '.xlsx';

const IMPORT_TYPES = {
  PROJECT: 'Project',
  PROJECT_ALLOCATION: 'ProjectAllocation',
  FGBS: 'FGBS',
  CC: 'CC',
  JC: 'JC',
  BUSINESS_COMPONENT_CREATE: 'BusinessComponentCreate',
  BUSINESS_COMPONENT_UPDATE: 'BusinessComponentUpdate',
  BUSINESS_COMPONENT_PROJECT_MAPPING: 'BusinessComponentProjectMapping',
  BUSINESS_COMPONENT_DELETE: 'BusinessComponentDelete',
  HR_AND_PAYROLL: 'HRAndPayroll',
  PAYROLL_ONLY: 'PayrollOnly',
  HR_SUPPLEMENTAL: 'HRSupplemental',
  CONTRACTS: 'ContractsData',
  SUPPLIES: 'SuppliesData',
  LABOR_GROUPING: 'LaborGrouping',
  CONTRACT_GROUPING: 'ContractsGrouping',
  UPDATE_SURVEY_DURATION: 'UpdateSurveyDuration',
  LABOR_DUAL_UPDATE_SURVEY_DURATION: 'LaborDualUpdateSurveyDuration',
  NOTIFICATION_SURVEY_FILTER: 'NotificationSurveyFilter',
};

export const SUPPORTED_IMPORT_TYPES = {
  QNQ_CC: [IMPORT_TYPES.CC, IMPORT_TYPES.FGBS],
  QNQ_JC: [IMPORT_TYPES.JC],
  QNQ_PROJECTS: [IMPORT_TYPES.PROJECT, IMPORT_TYPES.PROJECT_ALLOCATION],
  BUSINESS_COMPONENT: [
    IMPORT_TYPES.BUSINESS_COMPONENT_CREATE,
    IMPORT_TYPES.BUSINESS_COMPONENT_UPDATE,
    IMPORT_TYPES.BUSINESS_COMPONENT_PROJECT_MAPPING,
    IMPORT_TYPES.BUSINESS_COMPONENT_DELETE,
  ],
  POPULATION_LABOR: [
    IMPORT_TYPES.HR_AND_PAYROLL,
    IMPORT_TYPES.PAYROLL_ONLY,
    IMPORT_TYPES.HR_SUPPLEMENTAL,
  ],
  POPULATION_CONTRACTS: [IMPORT_TYPES.CONTRACTS],
  POPULATION_SUPPLIES: [IMPORT_TYPES.SUPPLIES],
  LABOR_GROUPING: [IMPORT_TYPES.LABOR_GROUPING],
  CONTRACT_GROUPING: [IMPORT_TYPES.CONTRACT_GROUPING],
  SURVEY: [IMPORT_TYPES.UPDATE_SURVEY_DURATION],
  LABOR_DUAL_SURVEY: [IMPORT_TYPES.LABOR_DUAL_UPDATE_SURVEY_DURATION],
  NOTIFICATION_SURVEY_FILTER: [IMPORT_TYPES.NOTIFICATION_SURVEY_FILTER],
};

export const IMPORT_TYPE_NAMES = {
  Project: 'Project',
  ProjectAllocation: 'Project Allocation',
  FGBS: 'FGBS',
  CC: 'Cost Center',
  JC: 'Job Code',
  BusinessComponentCreate: 'Create Business Component',
  BusinessComponentUpdate: 'Update Business Component',
  BusinessComponentProjectMapping: 'Map Business Component to Project',
  BusinessComponentDelete: 'Delete Business Component',
  HRAndPayroll: 'Personnel',
  PayrollOnly: 'Payroll',
  HRSupplemental: 'Personnel Supplemental',
  ContractsData: 'Contracts',
  SuppliesData: 'Supplies',
  LaborGrouping: 'Labor Grouping',
  ContractsGrouping: 'Contract Grouping',
  UpdateSurveyDuration: 'Update Duration',
  LaborDualUpdateSurveyDuration: 'Update Duration',
  NotificationSurveyFilter: 'NOTIFICATION SURVEY FILTER',
};

export const IMPORT_DISABLE_POSSIBLE = {
  Project: false,
  ProjectAllocation: false,
  FGBS: false,
  CC: true,
  JC: true,
  BusinessComponentCreate: true,
  BusinessComponentUpdate: false,
  BusinessComponentProjectMapping: true,
  BusinessComponentDelete: false,
  HRAndPayroll: false,
  PayrollOnly: false,
  HRSupplemental: false,
  ContractsData: true,
  LaborGrouping: false,
  SuppliesData: false,
  ContractsGrouping: true,
  UpdateSurveyDuration: false,
  LaborDualUpdateSurveyDuration: false,
  NotificationSurveyFilter: false,
};

export const IMPORT_STATUS = {
  Triggered: 'Triggered',
  InProgress: 'InProgress',
  Completed: 'Completed',
  PartiallyImportedWithValidationFailure: 'PartiallyImportedWithValidationFailure',
  ValidationFailure: 'ValidationFailure',
  PartiallyImportedWithSystemFailure: 'PartiallyImportedWithSystemFailure',
  SystemFailure: 'SystemFailure',
  Unknown: 'Unknown',
};

export const IMPORT_STATUS_NAME = {
  InProgress: 'In progress',
  Completed: 'Completed',
  Failed: 'Failed',
  Unknown: '-',
};
